/*
 * Application Insights JavaScript SDK - Core, 2.7.6
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


export var strIKey = "iKey";
export var strExtensionConfig = "extensionConfig";
